import styles from "./modal_popup.module.scss";

const ModalContainer = ({ children, onClose, zIndex = 1000 }) => {
  return (
    <div
      className={styles.popup_container}
      style={{ zIndex }}
      onClick={onClose} // close when clicking overlay
    >
      <div
        className={styles.popup_body}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default ModalContainer;